import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (filter) =>
    present(
      repository
        .getWorkLoads(filter)
        .then((workLoads) => ({ filter, workLoads }))
        .catch(() => Promise.reject(filter)),
    );
}

export type { Interactor };

export { createInteractor };
